export default "__VITE_ASSET__CUhfjwWk__"